import issueDescription from "./issue_description";
import reason from "./reason";

export default {
  issueDescription,
  reason,
  displayName: "Empty Parent",
  order: 60,
};
